import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import toastOverlayStyle from "./toast.overlay.component.css?string";
var _window = /*#__PURE__*/new WeakMap();
var _document = /*#__PURE__*/new WeakMap();
var _createStyles = /*#__PURE__*/new WeakMap();
export var ToastOverlayComponent = /*#__PURE__*/function (_HTMLElement) {
  function ToastOverlayComponent() {
    var _this;
    _classCallCheck(this, ToastOverlayComponent);
    _this = _callSuper(this, ToastOverlayComponent);
    _classPrivateFieldInitSpec(_this, _window, window);
    _classPrivateFieldInitSpec(_this, _document, _classPrivateFieldGet(_window, _this).document);
    _classPrivateFieldInitSpec(_this, _createStyles, function (css) {
      var style = _classPrivateFieldGet(_document, _this).createElement("style");
      style.textContent = css;
      return style;
    });
    var shadow = _this.attachShadow({
      mode: "open"
    });
    var styles = _classPrivateFieldGet(_createStyles, _this).call(_this, toastOverlayStyle);
    var slotElement = _classPrivateFieldGet(_document, _this).createElement("slot");
    shadow.appendChild(styles);
    shadow.appendChild(slotElement);
    return _this;
  }
  _inherits(ToastOverlayComponent, _HTMLElement);
  return _createClass(ToastOverlayComponent, [{
    key: "self",
    value: function self() {
      return this;
    }
  }, {
    key: "parent",
    value: function parent() {
      return this.parentNode;
    }
  }, {
    key: "getValue",
    value: function getValue(name) {
      name = "#__".concat(name);
      return this[name];
    }
  }, {
    key: "setValue",
    value: function setValue(name, value) {
      name = "#__".concat(name);
      this[name] = value;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));